import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputComponent } from './fc-search-input.component';


@NgModule({
  entryComponents: [
    FcSearchInputComponent
  ],
  declarations: [
    FcSearchInputComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    ScrollingModule,
    MatTooltipModule
  ],
  exports: [
    FcSearchInputComponent
  ]
})
export class FcSearchInputModule {}
